export default {
  avatarRules: [
    (value) =>
      !value || value.size < 3000000 || 'Avatar size should be less than 3 MB!'
  ],
  fieldRules: [(v) => !!v || 'This field is required'],
  emailRules: [
    (v) => !!v || 'E-mail is required',
    (v) => /.+@.+/.test(v) || 'E-mail must be valid'
  ],
  passwordRules: [
    (v) => !!v || 'Please type password.',
    (v) => (v && v.length >= 6) || 'minimum 6 characters'
  ],
  confirmPasswordRules: [
    (v) => !!v || 'Type confirm password',
    (v) => v === this.password || 'The password confirmation does not match.'
  ],
  fileRules: [
    (v) => !!v || 'Please upload required file',
    (v) => !v || v.size < 5000000 || 'File size should be less than 5 MB!'
  ]
}
